module.exports = __webpack_public_path__ + "static/media/return.1041fd0c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/return.svg
// module id = 54
// module chunks = 0